// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Bqbv","tab":"Tabs_tab__i_bZz","tabActive":"Tabs_tabActive__33dtt"};